"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconRelatedChats = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconRelatedChats = function SvgIconRelatedChats(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63636 1C4.13428 1 3.72727 1.40701 3.72727 1.90909V3.72728H7.81818C8.5713 3.72728 9.18182 4.3378 9.18182 5.09092V6.5194L10.6406 7.5614C10.791 7.66885 11 7.56132 11 7.37647V5.54885L11 5.54545V1.90909C11 1.40701 10.593 1 10.0909 1H4.63636ZM1 5.54534C1 5.04327 1.40701 4.63625 1.90909 4.63625H7.36364C7.86571 4.63625 8.27273 5.04327 8.27273 5.54534V9.18171C8.27273 9.68378 7.86571 10.0908 7.36364 10.0908H2.90919L1.35937 11.1978C1.20895 11.3053 1 11.1977 1 11.0129V9.18178V9.18171V5.54534Z",
    fill: "currentColor"
  }));
};

exports.SvgIconRelatedChats = SvgIconRelatedChats;